// @flow

import React, { PureComponent } from 'react';
import { i18n } from 'shared/utils';
import { graphql, fetchQuery } from 'react-relay';
import relayEnvironment from 'shared/gql/relayEnvironment';
import { FieldGroup } from 'shared/components/form';

type Props = {
  name?: string,
  rawField?: boolean,
  label?: ?string,
  error?: ?string,
  isSearchable?: boolean,
};

type State = {
  fetchedOptions: Array<Object>,
};

const QUERY = graphql`
  query SelectWarehouseLocationFieldQuery($search: String) {
    warehouseLocations(first: 300, search: $search) {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`;

class SelectWarehouseLocationField extends PureComponent<Props, State> {
  static defaultProps = {
    name: undefined,
    rawField: false,
    label: undefined,
    error: undefined,
    isSearchable: undefined,
  };

  mounted = false;

  state = {
    fetchedOptions: [],
  };

  componentDidMount() {
    this.mounted = true;
    this.getData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getData = async (inputValue?: string) => {
    try {
      const results = await fetchQuery(relayEnvironment, QUERY, {
        search: inputValue,
      });

      const edges = results.warehouseLocations?.edges || [];
      const options = edges.map(({ node }) => ({
        data: node,
        value: node.id,
        label: node.code ? `${node.name} (${node.code})` : node.name,
      }));

      if (this.mounted) {
        this.setState({ fetchedOptions: options });
      }

      return options;
    } catch (e) {
      return [];
    }
  };

  render() {
    const { name, rawField, label, error, ...fieldProps } = this.props;
    const { fetchedOptions } = this.state;

    return (
      <FieldGroup
        name={name}
        rawField={rawField || false}
        label={label !== undefined ? label : i18n.t('Default Location')}
        error={error}
        clearable
        placeholder={i18n.t('Select Location')}
        {...fieldProps}
        options={fetchedOptions}
        type="select"
        defaultOptions
      />
    );
  }
}

export default SelectWarehouseLocationField;
